import JWTDecode from "jwt-decode";
import { reset } from "redux-form";

import * as c from "./constants";
import * as storage from "../utils/storage";
import { redirectTo, alertBackendError } from "../utils";
import {getApiPrefix_globe, getApiPrefix_lagoon, getMainGlobeUrl} from "../constants";

export const setSample = () => ({
  type: c.CONSTANT,
  payload: { sample: true }
});

export const showLoader = bool => ({
  type: c.APP,
  payload: { loader: bool }
});

export const setAfterLoad = () => ({
  type: c.APP,
  payload: { afterLoad: true }
});

export const setAfterActivation = () => ({
  type: c.APP,
  payload: { afterActivation: true }
});

export const setActiveForm = (activeForm, activeFormData = null) => ({
  type: c.APP_FORM,
  payload: { activeForm, activeFormData }
});

export const formShowMore = state => ({
  type: c.APP_FORM,
  payload: { showMore: state }
});

export const resetForm = form => reset(form);

export const setAllowRedirect = allowRedirect => ({
  type: c.APP,
  payload: { allowRedirect }
});

const parseToken = token => dispatch => {
  const decoded = JWTDecode(token);
  const role = decoded.authorities;
  storage.set("role", JSON.stringify(role));
  storage.set("token", token);
  dispatch({
    type: c.ROLE,
    payload: { role }
  });
};

export const authRequest = OAuth2AuthCode => async dispatch => {
  let url = '';
  dispatch(showLoader(true));
  try {
    const response = await fetch( url= `${getApiPrefix_globe()}/login`, {
      headers: new Headers({
        OAuth2AuthCode
      })
    });

    console.log('OAuth2AuthCode',OAuth2AuthCode);

    if (response.status === 200) {
      const token = response.headers.get("bearer");
      dispatch(parseToken(token));
      dispatch(showLoader(false));
      return true;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
      dispatch(showLoader(false));
    }
    else if( response.status === 401 )
    {

    }

    dispatch(showLoader(false));
    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception,url});
    dispatch(showLoader(false));
    return false;
  }
};

export const signOut = () => {
  console.log('SignOut');
  storage.remove("token");
  storage.remove("role");
  storage.remove("globeToken");
  window.sessionStorage.removeItem("globeToken");
  redirectTo(getMainGlobeUrl());
};

export const setActivateAccount = activateAccount => ({
  type: c.APP,
  payload: { activateAccount }
});

export const setButtonsClickData = data => ({
  type: c.APP,
  payload: { data }
});



// WEBPACK FOOTER //
// ./src/actions/appActions.js